// Generated by purs version 0.15.15
var unload = "unload";
var toggle = "toggle";
var submit = "submit";
var storage = "storage";
var select = "select";
var reset = "reset";
var readystatechange = "readystatechange";
var progress = "progress";
var paste = "paste";
var online = "online";
var offline = "offline";
var message = "message";
var loadstart = "loadstart";
var loadend = "loadend";
var load = "load";
var languagechange = "languagechange";
var invalid = "invalid";
var input = "input";
var focus = "focus";
var error = "error";
var domcontentloaded = "DOMContentLoaded";
var cut = "cut";
var copy = "copy";
var close = "close";
var click = "click";
var change = "change";
var cancel = "cancel";
var blur = "blur";
var beforescriptexecute = "beforescriptexecute";
var beforeprint = "beforeprint";
var afterscriptexecute = "afterscriptexecute";
var afterprint = "afterprint";
var abort = "abort";
export {
    abort,
    afterprint,
    afterscriptexecute,
    beforeprint,
    beforescriptexecute,
    blur,
    cancel,
    change,
    click,
    close,
    copy,
    cut,
    domcontentloaded,
    error,
    focus,
    input,
    invalid,
    languagechange,
    load,
    loadend,
    loadstart,
    message,
    offline,
    online,
    paste,
    progress,
    readystatechange,
    reset,
    select,
    storage,
    submit,
    toggle,
    unload
};
//# sourceMappingURL=index.js.map
